import {useCuedTrack} from '@app/web-player/player-controls/use-cued-track';
import {getTrackInfoLink} from '@app/web-player/tracks/track-link';
import {IconButton} from '@ui/buttons/icon-button';
import {Trans} from '@ui/i18n/trans';
import {InfoIcon} from '@ui/icons/material/Info';
import {Tooltip} from '@ui/tooltip/tooltip';
import {Link} from 'react-router';

export function TrackInfoButton() {
  const track = useCuedTrack();

  if (!track) {
    return null;
  }

  return (
    <Tooltip label={<Trans message="Track Info" />}>
      <IconButton elementType={Link} to={getTrackInfoLink(track)}>
        <InfoIcon />
      </IconButton>
    </Tooltip>
  );
}
